/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Container } from '@material-ui/core'
import Widget from '../Dashboard/Widget/Widget'
import { useStyles } from './Styles'
import Logo from '../Logo'
import { NavLink } from 'react-router-dom'
import { NamedRoutes } from '../../routes'

const AdminSections = ({ handleAdminSectionChange }) => {

  const classes = useStyles()
  React.useEffect(() => {
      if (!!handleAdminSectionChange) {
        handleAdminSectionChange('')
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <div className={classes.AnonymousWrapper}>
      <Container maxWidth={'md'} className={classes.AnonymousContainer}>
        <NavLink to={NamedRoutes.workspace.home} onClick={() => handleAdminSectionChange('workspace')}
                 className={classes.adminSectionContainer}>
          <Widget
            upperTitle
            disableWidgetMenu
            bodyClass={classes.AnonymousWidget}
          >
            <Logo noLink/>
            <p><FormattedMessage id='AdminSection.Workspace.Title'/></p>
          </Widget>
        </NavLink>
        <NavLink to={NamedRoutes.subscription.home} onClick={() => handleAdminSectionChange('subscription')}
                 className={classes.adminSectionContainer}>
          <Widget
            upperTitle
            disableWidgetMenu
            bodyClass={classes.AnonymousWidget}
          >
            <Logo noLink/>
            <p><FormattedMessage id='AdminSection.Subscription.Title'/></p>
          </Widget>
        </NavLink>
      </Container>

    </div>
  )
}

export default AdminSections
